/**
 * PHARMAKON — BETA mode banner.
 *
 * Always-visible sticky banner shown across the AppShell while the user is
 * exploring the Try-Before-Purchase demo. Surfaces the active demo role
 * and a one-click exit that wipes the mock store and returns to /login.
 */
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@/components/ui/primitives";
import { isBetaMode, getBetaRole, exitBeta } from "@/mock/beta-mode.js";
import { useAuthStore } from "@/stores/authStore.js";
import { ROLE_LABELS } from "@/config/app.config.js";

export default function BetaBanner() {
  const navigate = useNavigate();
  if (!isBetaMode()) return null;
  const role = getBetaRole();

  const onExit = () => {
    exitBeta();
    useAuthStore.setState({ user: null });
    navigate("/login");
  };

  return (
    <div
      className="sticky top-0 z-30 flex items-center gap-3 px-4 py-1.5 text-2xs font-medium"
      style={{
        background:
          "linear-gradient(90deg, rgba(245,158,11,0.18), rgba(236,72,153,0.18))",
        borderBottom: "1px solid rgba(245,158,11,0.35)",
        color: "var(--color-text-strong, #92400e)",
      }}
    >
      <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded bg-amber-500/15 border border-amber-500/40 uppercase tracking-wider font-bold">
        <Icon name="sparkles" size={11} />
        Démo BETA
      </span>
      <span className="text-text-default truncate">
        Vous explorez PHARMAKON en tant que{" "}
        <strong>{ROLE_LABELS[role] || role}</strong> — toutes les modifications
        sont locales et seront perdues à la déconnexion.
      </span>
      <button
        type="button"
        onClick={onExit}
        className="ml-auto inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-white/60 dark:bg-black/30 hover:bg-white dark:hover:bg-black/50 border border-amber-500/40 transition-colors font-semibold whitespace-nowrap"
        title="Quitter la démo et revenir à la connexion"
      >
        <Icon name="log-out" size={12} />
        Quitter la démo
      </button>
    </div>
  );
}
